
function singles(frame, wrappers) {
  // sets the height of any frame passed in with the
  // tallest preventOverflowContent as well as any image in that frame
  const padding = 64;
  let tallest = 0;

  wrappers.forEach(wrap => {
    if (wrap.offsetHeight > tallest) {
      tallest = wrap.offsetHeight;
    }
  });
  const images = frame.querySelectorAll('[data-overflow-background]');
  const frames = [
    frame,
    ...images,
  ];
  frames.forEach(el => {
    el.style.setProperty('min-height', `${(tallest + padding)}px`);
  });
}

function doubles(section) {
  if (window.innerWidth <= window.theme.sizes.medium) {
    // if we are below the small breakpoint, the double section acts like two independent
    // single frames
    let singleFrames = section.querySelectorAll('[data-overflow-frame]');
    singleFrames.forEach(singleframe => {
      const wrappers = singleframe.querySelectorAll('[data-overflow-content]');
      singles(singleframe, wrappers);
    });
    return;
  }

  const padding = 64;
  let tallest = 0;

  const frames = section.querySelectorAll('[data-overflow-frame]');
  const contentWrappers = section.querySelectorAll('[data-overflow-content]');
  contentWrappers.forEach(content => {
    if (content.offsetHeight > tallest) {
      tallest = content.offsetHeight;
    }
  });
  const images = section.querySelectorAll('[data-overflow-background]');
  let applySizes = [
    section,
    ...frames,
    ...images,
  ];
  applySizes.forEach(el => {
    el.style.setProperty('min-height', `${(tallest + padding)}px`);
  });
}


function preventOverflow(container) {
  const singleFrames = container.querySelectorAll('.preventOverflow');
  if (singleFrames) {
    singleFrames.forEach(frame => {
      const wrappers = frame.querySelectorAll('.preventOverflowContent');
      singles(frame, wrappers);
      document.addEventListener('theme:resize', () => {
        singles(frame, wrappers);
      });
    });
  }

  const doubleSections = container.querySelectorAll('[data-overflow-wrapper]');
  if (doubleSections) {
    doubleSections.forEach(section => {
      doubles(section);
      document.addEventListener('theme:resize', () => {
        doubles(section);
      });
    });
  }
}

export default preventOverflow;
